import axios from 'axios';
import { URL_GENDERS_LIST } from './config';

export async function getGendersList() {
    const result = await axios.get(URL_GENDERS_LIST);
    return result.data.data;
};

